import { AdminClassroomLayout } from "@/pages/admin/AdminClassroomLayout";
import { StudentDetailPage } from "@/pages/teacher/StudentDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/classrooms/$classroomId/students/$studentId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { classroomId, studentId } = Route.useParams();
  return (
    <AdminClassroomLayout>
      <StudentDetailPage classroomId={classroomId} studentId={studentId} scope="admin" />
    </AdminClassroomLayout>
  );
}
